// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"53c8f8bf","747":"a09267a2"}[chunkId] + ".chunk.js";
};